import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, where, onSnapshot } from "firebase/firestore";

// These are the collections that feed the journal timeline.
// Operational logs (bottles, sleep, diapers) are intentionally excluded —
// the journal is a curated "baby book", not a data dump.
const SOURCES = [
  { key: "journalEntries",    type: "journal"     },
  { key: "milestones",        type: "milestone"   },
  { key: "growthHealth",      type: "growth"      },
  { key: "vaccinations",      type: "vaccination" },
  { key: "foodIntroductions", type: "foodIntro"   },
];

export const useJournalFeed = (childId) => {
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!childId) { setEvents([]); setLoading(false); return; }

    // Mutable per-collection buckets updated by each listener
    const buckets = Object.fromEntries(SOURCES.map(({ key }) => [key, []]));
    const loaded  = new Set();

    const rebuild = () => {
      const all = [];
      SOURCES.forEach(({ key, type }) =>
        buckets[key].forEach((item) => all.push({ ...item, _type: type }))
      );
      all.sort((a, b) => {
        const da = new Date(a.date || a.createdAt || 0);
        const db_ = new Date(b.date || b.createdAt || 0);
        return db_ - da; // newest first
      });
      setEvents(all);
      if (loaded.size === SOURCES.length) setLoading(false);
    };

    const unsubs = SOURCES.map(({ key }) => {
      const q = query(collection(db, key), where("childId", "==", childId));
      return onSnapshot(
        q,
        (snap) => {
          buckets[key] = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
          loaded.add(key);
          rebuild();
        },
        (err) => {
          console.error(`Journal feed error (${key}):`, err);
          loaded.add(key);
          if (loaded.size === SOURCES.length) setLoading(false);
        }
      );
    });

    return () => unsubs.forEach((u) => u());
  }, [childId]);

  return { events, loading };
};
